import React from "react";
import { BACKEND_URL } from "../lib/api";
import BlurHashImage from "./BlurHashImage";

function absUrl(u) {
  if (!u) return "";
  const url = u.startsWith("http") ? u : BACKEND_URL + u;
  return url.startsWith(BACKEND_URL + "/api/files/")
    ? url + (url.includes("?") ? "&" : "?") + "variant=thumb"
    : url;
}

// Renders a real image if design.image_url is provided; otherwise a deterministic placeholder tile.
const PALETTES = [
  { bg: "#141413", fg: "#FAF7F2", tag: "#D95328" },
  { bg: "#FAF7F2", fg: "#141413", tag: "#D95328" },
  { bg: "#D95328", fg: "#FAF7F2", tag: "#141413" },
  { bg: "#F3EDE2", fg: "#141413", tag: "#D95328" },
  { bg: "#2A2A28", fg: "#FAF7F2", tag: "#D95328" },
  { bg: "#57534E", fg: "#FAF7F2", tag: "#F3EDE2" },
];

function hash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h;
}

export default function DesignTile({ design, size = "md" }) {
  const imageUrl = design.image_url || design.images?.[0];
  if (imageUrl) {
    return (
      <div className="relative w-full aspect-square overflow-hidden bg-[#F3EDE2]" data-testid={`design-tile-${design.design_id}`}>
        <BlurHashImage
          src={absUrl(imageUrl)}
          blurHash={design.blurhash}
          alt={`${design.name} — ${design.design_id}`}
          className="w-full h-full object-contain"
        />
</div>
    );
  }
  const p = PALETTES[hash(design.design_id) % PALETTES.length];
  const isBig = size === "lg";
  return (
    <div
      className="relative w-full aspect-square overflow-hidden select-none"
      style={{ background: p.bg, color: p.fg }}
      data-testid={`design-tile-${design.design_id}`}
      aria-label={`${design.name} placeholder mockup`}
    >
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
          backgroundSize: "24px 24px",
        }}
      />
      <div className="absolute inset-0 flex flex-col justify-between p-5">
        <div className="flex items-start justify-end">
          <span
            className="text-[10px] font-mono uppercase tracking-widest px-2 py-0.5"
            style={{ background: p.tag, color: p.bg }}
          >
            {design.category}
          </span>
        </div>
        <div>
          <div
            className={`font-black uppercase leading-none ${isBig ? "text-5xl" : "text-3xl"}`}
            style={{ fontFamily: "Barlow Condensed, sans-serif" }}
          >
            {design.name}
          </div>
          <div className="mt-2 text-[10px] font-mono uppercase tracking-widest opacity-70">
            PrintMyTees • Sample Mockup
          </div>
        </div>
      </div>
    </div>
  );
}
